// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x5EH","content":"styles_content__qjrzh","tableWrap":"styles_tableWrap__2AdGC"};